import * as React from 'react';

type UseKeyboardFocuserParams = {
  isExpanded: boolean;
  pillsToShow: number;
};

type UseKeyboardFocuserReturn = {
  containerRef: React.RefObject<HTMLDivElement>;
  handleKeyboardEvent: () => void;
};

type HandleKeyboardEvent = () => void;

export const useKeyboardFocuser = ({ isExpanded, pillsToShow }: UseKeyboardFocuserParams): UseKeyboardFocuserReturn => {
  const isKeyboardEvent = React.useRef<boolean>(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isExpanded && isKeyboardEvent.current && containerRef.current) {
      // Using `querySelectorAll` here to avoid having to map through `visiblePills` to
      // add a ref to the first expanded element with `React.cloneElement`
      const pillElements = containerRef.current.querySelectorAll('[role="button"]');
      const firstExpandedPill: HTMLElement | undefined =
        pillElements[pillsToShow] instanceof HTMLElement ? pillElements[pillsToShow] : undefined;

      firstExpandedPill?.focus();
    }

    isKeyboardEvent.current = false;
  }, [isExpanded, pillsToShow]);

  const handleKeyboardEvent = React.useCallback<HandleKeyboardEvent>(() => {
    isKeyboardEvent.current = true;
  }, []);

  return {
    containerRef,
    handleKeyboardEvent,
  };
};

export default useKeyboardFocuser;
